export enum AnswerOption {
    A = "A",
    B = "B",
    C = "C",
  }